import { useTranslation } from 'react-i18next'

import { buttonClasses } from '@/design-system/Button'

import { readStringSetting } from '../types'

/**
 * Le lien `wa.me` d'un numéro saisi par l'équipe, ou `null`.
 *
 * `wa.me` n'accepte que les chiffres, indicatif compris et sans « + » : un
 * numéro recopié tel quel (« +49 170 123 45 67 ») ouvrirait une page d'erreur
 * WhatsApp. On nettoie donc ici plutôt que d'exiger un format au back-office.
 * Moins de huit chiffres, ce n'est pas un numéro international : mieux vaut
 * ne rien montrer qu'un bouton qui mène nulle part.
 */
export function whatsappUrl(settings: Record<string, unknown> | undefined): string | null {
  const digits = readStringSetting(settings ?? {}, 'contact.whatsapp').replace(/\D/g, '')
  return digits.length >= 8 ? `https://wa.me/${digits}` : null
}

/** Le bouton « Écrire sur WhatsApp » — absent tant qu'aucun numéro n'est réglé. */
export function WhatsAppLink({
  settings,
  size = 'md',
  className,
}: {
  settings: Record<string, unknown> | undefined
  size?: 'sm' | 'md'
  className?: string
}) {
  const { t } = useTranslation()
  const url = whatsappUrl(settings)
  if (!url) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={buttonClasses({ variant: 'outline', size, ...(className ? { className } : {}) })}
    >
      {t('contact.whatsapp')}
    </a>
  )
}
